"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOccasionCampaignStencil = exports.occasionCampaignStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.occasionCampaignStencilDefinition = {
    view: {
        label: 'Occasion Campaign',
        group: 'Misc.',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'zoe-embed',
                    'title',
                    'teaser',
                    'legal-disclaimer',
                    'story-content',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'label',
                            'uri-title',
                            'featured-media',
                            'social-title',
                            'featured-title',
                            'seo-title',
                            'social-media-image',
                            'geolocation',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'standalone',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: ['content-categories'],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.contentClassificationTermsPropertyDefinition.name]: properties_1.contentClassificationTermsPropertyDefinition,
        [properties_1.ctaContainerPropertyDefinition.name]: {
            ...properties_1.ctaContainerPropertyDefinition,
            constraints: [
                {
                    name: 'properties',
                    argument: [
                        'cta-url',
                        'cta-asset',
                        'cta-anchor',
                    ],
                },
            ],
        },
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.geolocationPropertyDefinition.name]: properties_1.geolocationPropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: {
            ...properties_1.headerMediaPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['image'],
                },
            ],
        },
        [properties_1.labelPropertyDefinition.name]: {
            ...properties_1.labelPropertyDefinition,
            view: { label: 'Internal Title' },
        },
        [properties_1.legalDisclaimerPropertyDefinition.name]: properties_1.legalDisclaimerPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialMediaImagePropertyDefinition.name]: properties_1.socialMediaImagePropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: {
            ...properties_1.socialTitlePropertyDefinition,
            view: { label: 'Social Media Title' },
        },
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: false,
        },
        [properties_1.storyContentPropertyDefinition.name]: properties_1.storyContentPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: {
            ...properties_1.teaserPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'maxLength',
                    argument: 250,
                },
            ],
        },
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: {
            ...properties_1.uriTitlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
            ],
        },
        [properties_1.zoeEmbedPropertyDefinition.name]: properties_1.zoeEmbedPropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: ['cartoons'],
    name: 'occasion-campaign',
};
const isOccasionCampaignStencil = (stencil) => {
    return stencil.name === exports.occasionCampaignStencilDefinition.name;
};
exports.isOccasionCampaignStencil = isOccasionCampaignStencil;
//# sourceMappingURL=data:application/json;base64,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